// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1899":"63bbc16c","2255":"3b1e880a","3561":"63bbc16c","4621":"63bbc16c","5081":"63bbc16c","6092":"63bbc16c","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};